module.exports = __webpack_public_path__ + "img/teatox.a8a7d3ed.jpg";